import { Factory } from "./../core/factory";

import { BaseMark } from "./base/base-mark";

import { registerRippleGlyph } from "@visactor/vgrammar-core";

export class RippleMark extends BaseMark {
    constructor() {
        super(...arguments), this.type = RippleMark.type;
    }
    _getDefaultStyle() {
        return Object.assign(Object.assign({}, super._getDefaultStyle()), {
            x: 0,
            y: 0,
            ripple: 0
        });
    }
    _initProduct(group) {
        const view = this.getVGrammarView(), id = this.getProductId();
        this._product = view.glyph("ripplePoint", null != group ? group : view.rootMark).id(id), 
        this._compiledProductId = id;
    }
}

RippleMark.type = "ripple";

export const registerRippleMark = () => {
    Factory.registerMark(RippleMark.type, RippleMark), registerRippleGlyph();
};
//# sourceMappingURL=ripple.js.map
